import { ReferenceMonth } from 'bold-ui'
import { format, parse } from 'date-fns'
import { toDate } from 'util/date/formatDate'

export const convertDataPreventivoMonthYearToDataPreventivoLocalDate = (dataPreventivo: ReferenceMonth) => {
  const { year, month } = dataPreventivo || {}

  return dataPreventivo ? format(new Date(year, month, 1), 'yyyy-MM-dd') : null
}

export const converDataPreventivoLocalDateToDataPreventivoMonthYear = (dataPreventivo: LocalDate) => {
  if (dataPreventivo) {
    const date = toDate(dataPreventivo)
    return {
      month: date ? date.getMonth() : undefined,
      year: date ? date.getFullYear() : undefined,
    }
  }
  return null
}

export const convertDataPreventivoLocalDateToString = (dataPreventivo: LocalDate) => {
  if (!dataPreventivo) return ''

  const date = parse(dataPreventivo, 'dd/MM/yyyy', new Date())
  return format(date, 'MM/yyyy')
}
